// A single shell command with a copy-to-clipboard button and an optional
// trailing comment describing what it does. Shared by the docs pages;
// extracted from the original quick-start page.

import { IconCheck, IconCopy } from "@tabler/icons-react";
import { useCopy } from "@/lib/use-copy";
import { Button } from "@/components/ui/button";

export function CommandLine({ command, comment }: { command: string; comment?: string }) {
  const { copied, copy } = useCopy();

  return (
    <div className="flex items-center gap-2 rounded-md border bg-muted/50 px-3 py-2">
      <code className="min-w-0 flex-1 font-mono text-sm break-all">
        <span className="mr-2 text-muted-foreground select-none">$</span>
        {command}
        {comment && <span className="ml-3 text-muted-foreground select-none">— {comment}</span>}
      </code>
      <Button
        variant="ghost"
        size="icon-sm"
        className="shrink-0"
        aria-label={`Copy: ${command}`}
        onClick={() => void copy(command)}
      >
        {copied ? <IconCheck className="text-emerald-500" /> : <IconCopy />}
      </Button>
    </div>
  );
}
